import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 2,
  title: "Hard Water Minerals Create 'Invisible Soap Scale' That Traps Moisture and Disrupts pH",
  titleImages: [{
    url: 'https://cdn.magicpatterns.com/uploads/tDyPWZccrJCwDe7j3NrY5a/unnamed_(4).jpg',
    alt: 'Scientific diagram showing chlorine Cl2 molecules vaporizing from hot water at 42°C with vapor escape arrows and open skin pores at 50 micron scale'
  }],
  mechanism: <>
      Australian tap water contains calcium and magnesium/minerals that, when
      combined with soap, create an <strong data-id="element-87">insoluble substance</strong> called
      soap scale. You've seen this on shower walls (white buildup). But this
      same buildup forms on your toddler's skin at a{' '}
      <strong data-id="element-88">microscopic level</strong>.
    </>,
  avatars: {},
  bridge: <>
      Creams can moisturize the surface, but they <strong data-id="element-89">can't remove</strong>{' '}
      the soap scale barrier that prevents{' '}
      <strong data-id="element-90">natural moisture function</strong>.
    </>,
  imageOnLeft: true
};
export function Item2Section() {
  return <ItemSection data={data} data-id="element-91" />;
}